// Cross-component signal that the org contact-tag dictionary (or tag usage
// counts) changed — fired after any create/remove/apply (the Manage Tags
// modal, ContactTagsModal, the Smart Tagging PreviewCard's buttons, and the
// assistant's apply_contact_tags result card). The Manage Tags modal and the
// DonorsTable Tags filter listen and refetch so counts/lists update live.
export const ORG_CONTACT_TAGS_UPDATED_EVENT = 'charitystack:org-contact-tags-updated';

export function notifyOrgContactTagsUpdated() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(ORG_CONTACT_TAGS_UPDATED_EVENT));
}
